<div class="table-component card card-with-no-padding">
    <p-table
        [value]="data()"
        [columns]="cols()"
        scrollHeight="500px"
        [responsiveLayout]="'scroll'"
        [loading]="loading()"
        [paginator]="pagination()"
        [rows]="rowsPerPage()"
        [showFirstLastIcon]="false"
        [showPageLinks]="false"
        [first]="first"
        stripedRows
        class="m-0"
    >
        <ng-template pTemplate="caption">
            <ng-content select="[tableCaption]"></ng-content>
        </ng-template>
        <ng-template #header let-columns>
            <tr>
                <th *ngFor="let column of columns" class="table-header">{{ column.label }}</th>
            </tr>
        </ng-template>
        <ng-template #body let-course let-columns="columns" let-rowIndex="rowIndex">
            <tr [style.background-color]="rowIndex % 2 === 0 ? evenRowColor() : oddRowColor()">
                <td *ngFor="let column of columns" class="table-body">
                    @if (column.template) {
                        <ng-container *ngTemplateOutlet="column.template; context: { rowData: course }"></ng-container>
                    } @else if (column.formatter) {
                        {{ course[column.key] | dynamicFormatter: column.formatter }}
                    } @else {
                        {{ course[column.key] }}
                    }
                </td>
            </tr>
        </ng-template>

        <ng-template #emptymessage>
            <tr>
                <td colspan="12">No data found.</td>
            </tr>
        </ng-template>
    </p-table>

    <hr *ngIf="pagination()" />

    <!-- Custom Pagination -->
    <div class="flex justify-between items-center" *ngIf="pagination()">
        <span class="pagination-text">Page {{ currentPage }} of {{ totalPages }}</span>
        <div class="flex gap-[12px]">
            <p-button label="Previous" outlined [disabled]="currentPage === 1" (click)="previousPage()" />
            <p-button label="Next" outlined [disabled]="currentPage === totalPages" (click)="nextPage()" />
        </div>
    </div>
</div>
